import { CommonLogger, LogLevel } from '@evinced-private/ui-common';

const remoteLogLevelConfig = import.meta.env.VITE_SERVER_LOG_LEVEL;
const consoleLogLevelConfig = import.meta.env.VITE_CONSOLE_LOG_LEVEL;
const remoteLogLevelThreshold = LogLevel[remoteLogLevelConfig as keyof typeof LogLevel];
const consoleLogLevelThreshold = LogLevel[consoleLogLevelConfig as keyof typeof LogLevel];
const hostname = window.location.host;
const productName = 'product-hub';

export const Logger = new CommonLogger();

Logger.init({
	remoteLogLevelThreshold,
	consoleLogLevelThreshold,
	productName,
	hostname
});
